export default {
  errors: [],
  imageInfo: [],
  images: [],
  profileCardPictureChange: 0
};
